import React, { useEffect } from "react";
import { Toast } from "./../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { create } from "../../helpers/api/condominium";
import PageHeader from "../common/PageHeader";
import CreateCondominiumForm from "./CreateCondominiumForm";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useDispatch, useSelector } from "react-redux";
import SupportLink from "../root/support/components/SupportLink";
import { SelectCondominium } from "../../actions/condominiumActions";

const CreateCondominium = ({ setRedirectUrl, setRedirect }) => {
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.auth.user);
  const { selectedCondominium } = useSelector((state) => state.condominium);

  const onSubmitData = async (values) => {
    try {
      const { code, errors, data } = await create(values); // Si la API responde OK
      if (code === SUCCESS_RESPONSE.CREATED) {
        // HO-HU-36: si el manager no tenia ningun condominio seleccionado --el
        // caso de quien recien se registro y acaba de crear el primero, donde
        // la auto-seleccion del login no llega porque en ese momento todavia
        // tenia cero-- el nuevo queda seleccionado y se lo lleva al Inicio,
        // que es donde esta la guia de primeros pasos. Antes caia en el
        // listado y tenia que ir a buscarlo y clickearlo.
        //
        // Si ya estaba trabajando sobre otro condominio no se le mueve el
        // contexto por debajo: crear el condominio numero 6 mientras
        // administra el 2 no deberia sacarlo del 2.
        if (role === "manager" && !selectedCondominium && data?.condominium_id) {
          dispatch(
            SelectCondominium(
              data.condominium_id,
              data.name,
              data.address,
              data.identification
            )
          );
          setRedirectUrl("/dashboard/app");
        }

        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Condominio registrado exitosamente.`,
        });
      } else {
        handleErrorMessage({ code, errors });
      }
    } catch (error) {
      if (error?.data?.code === "H0013" && error?.data?.errors?.acronym) {
        Toast.fire({
          type: "error",
          title: "El acrónimo ya está en uso.",
        });
      } else {
        handleErrorMessage(error);
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (role === "root") setRedirectUrl(`/root/condominiums`);
    else setRedirectUrl(`/dashboard/condominiums`);
    // eslint-disable-next-line
  }, [setRedirectUrl]);

  return (
    <>
      <PageHeader
        title="Crear nuevo condominio"
        titleTag="h2"
        description="Crea un nuevo condominio y gestionalo al instante."
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <CreateCondominiumForm handleSubmitData={onSubmitData} />
    </>
  );
};

export default withRedirect(CreateCondominium);
